import TermsOfUseComponent from './TermsOfUseComponent'

export default TermsOfUseComponent
